type Library = "geometry" | "places";
export default class GoogleMapsConfig {
  static libraries : Library[] = ["geometry", "places"];

  getLibraries = () => GoogleMapsConfig.libraries;
}
